import React from 'react';
import { Card, CardProps, Container } from 'react-bootstrap';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type customContactCardsProps = CardProps &
  React.PropsWithChildren<{
    className?: string;
    title?: string;
    titleNode?: React.ReactNode;
    titleIcon?: IconProp;
    img?: string;
    medicalGroup?: string;
    status?: string;
    statusIcon?: IconProp;
    contactButtons?: React.ReactNode;
    button?: React.ReactNode;
  }>;

const ContactCard = ({
  className,
  title,
  titleIcon,
  titleNode,
  img,
  medicalGroup,
  status,
  statusIcon,
  contactButtons,
  button,
  bg = 'white',
}: customContactCardsProps) => {
  return (
    <Card bg={bg} bsPrefix={'custom-contact-card '} className={'col-3'}>
      <Card.Body className={className}>
        <Container className={'mx-0 px-0 d-flex mb-10 align-items-center'}>
          {titleIcon && (
            <span className={'left-icon text-blue'}>
              <FontAwesomeIcon icon={titleIcon} />
            </span>
          )}
          {title && <h6 className="mb-0 ms-4 text-fs-6 text-blue">{title}</h6>}
          {titleNode && <div className="title-node">{titleNode}</div>}
        </Container>

        <Container className={'mx-0 px-0'}>
          <Container className={'px-0'}>
            {img && (
              <div
                className={
                  'logo-wrapper mx-auto d-flex justify-content-center align-items-center'
                }
              >
                <Card.Img
                  src={img}
                  className={'d-block my-0 mx-auto card-img'}
                />
              </div>
            )}
          </Container>
          {medicalGroup && (
            <Container className={'px-6 py-4'}>
              <Container
                className={'status d-flex flex-column  align-items-center'}
              >
                <h6 className={'text-fs-6 mb-0'}>{medicalGroup}</h6>
                {status && (
                  <span
                    className={'text-caption d-flex align-items-center mt-2'}
                  >
                    {status}
                    {statusIcon && (
                      <span className="right-icon ms-1 text-fs-6">
                        <FontAwesomeIcon icon={statusIcon} />
                      </span>
                    )}
                  </span>
                )}
              </Container>
            </Container>
          )}

          <Container className={'mx-0 mt-7 px-0 d-flex justify-content-center'}>
            {contactButtons}
          </Container>
        </Container>

        {button && <Container className={'mx-0 px-0'}>{button}</Container>}
      </Card.Body>
    </Card>
  );
};

export default ContactCard;
